import { PrimerStatusEnum } from '@shared/enums';
import { SampleStatusEnum } from '@shared/enums/sample-status.enum';

export const primerStatusNames: Record<PrimerStatusEnum, string> = {
    [PrimerStatusEnum.ALL]: 'inventory.primer.status.all',
    [PrimerStatusEnum.AVAILABLE]: 'inventory.primer.status.available',
    [PrimerStatusEnum.PENDING]: 'inventory.primer.status.pending',
    [PrimerStatusEnum.OUT_OF_STOCK]: 'inventory.primer.status.outOfStock',
};

export const sampleStatusNames: Record<SampleStatusEnum, string> = {
    [SampleStatusEnum.ALL]: 'inventory.sample.status.all',
    [SampleStatusEnum.AVAILABLE]: 'inventory.sample.status.available',
    [SampleStatusEnum.EXPIRED]: 'inventory.sample.status.expired',
    [SampleStatusEnum.NOT_RECEIVED]: 'inventory.sample.status.notReceived',
    [SampleStatusEnum.DISPOSED]: 'inventory.sample.status.disposed',
};
